import { option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { createSelector } from 'reselect';

import { getStringProp } from '@mews/fp';

import { ApplicationState } from '../../../types';
import { getEntities } from '../getEntities';
import { Entities } from '../types';

import { ProductPricing } from './types';

const getProductPricingEntity = createSelector<ApplicationState, Entities, ProductPricing>(
    getEntities,
    (entities) => entities.productPricing
);

const getProductPricingData = createSelector(getProductPricingEntity, (productPricing) => productPricing.data);
const getProductPricingMeta = createSelector(getProductPricingEntity, (productPricing) => productPricing.meta);

export const hasProductPricing = createSelector(
    getProductPricingData,
    getStringProp('productPricingHash'),
    (productPricing, productPricingHash) => Boolean(productPricing[productPricingHash])
);

export const getProductPricingProducts = createSelector(
    getStringProp('productPricingHash'),
    getProductPricingData,
    (productPricingHash, productPricing) => pipe(productPricing[productPricingHash], option.fromNullable)
);

export const getProductPricingMetaValue = createSelector(
    getStringProp('productPricingHash'),
    getProductPricingMeta,
    (productPricingHash, productPricing) => pipe(productPricing[productPricingHash], option.fromNullable)
);
